<template>
  <action-modal
    headline="When would you like to reschedule this campaign for?"
    button-label="Reschedule Campaign"
    button-type="warning"
    :action-url="actionUrl"
    v-on:date-selected="onDateSelected"
    :action-params="actionParams"
    :date-time="true"
    :timezone="timezone"
    :redirect-url="redirectUrl"
  >
  </action-modal>
</template>

<script>
import ActionModal from '../../../ActionModal';

export default {
  name: 'reschedule-campaign-modal',
  components: {ActionModal},
  props: {
    campaignId: {
      required: true,
      type: Number,
    },
    vesselId: {
      required: true,
      type: Number,
    },
    redirectUrl: {
      required: true,
      type: String,
    },
    timezone: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      launchDate: null,
    };
  },
  computed: {
    actionParams() {
      return {vesselId: this.vesselId, launch: this.launchDate};
    },
    actionUrl() {
      return '/api/?entity=campaigns&action=reschedule&cid=' + this.campaignId;
    },
  },
  methods: {
    onDateSelected(date) {
      this.launchDate = date;
    },
  },
};
</script>
